import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { ScaiService } from 'src/app/services/api/scai/scai.service';
import { CharacteristicsConverter } from 'src/app/services/api/characteristics/characteristics.converter';

@Component({
  selector: 'app-order-details-services',
  templateUrl: './order-details-services.component.html',
  styleUrls: ['./order-details-services.component.css']
})
export class OrderDetailsServicesComponent implements OnInit {

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }
  _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }
  @Input() isps: any[];

  previousId: string;

  scaiReference: string;
  generalInfo: OrderDetailsGeneralObject;
  inventoryUrl: string;

  characteristics: CharacteristicsObject;


  constructor(private ordersService: OrdersService,
    private scaiService: ScaiService,
    private characteristicsConverter: CharacteristicsConverter) {
  }

  ngOnInit() {
    if (this._params && this._summary && (this.previousId !== this._summary.id || this._summary.isReload)) {
      this.generalInfo = OrderDetailsGeneralObject.create();
      this.scaiReference = null;
      this.previousId = this._summary.id;
      if (this._params.type === 'rfs' && this._summary.processes[0] && this._summary.processes[0].originIdScai) {
        this.getScaiReference();
      }
      this.getCharacteristics();
    }
  }

  private getScaiReference(): void {
    this.scaiService.getScaiReference(this._summary.serviceRef, this._summary.processes[0].originIdScai).subscribe(
      (data) => {
        data._links = undefined;
        this.scaiReference = JSON.stringify(data, null, 2);
      }
    );
  }

  private getCharacteristics(): void {
    this.ordersService.getServiceCharacteristics(this._params.map).subscribe(
      (data) => {
        data.in.sort(function(a, b){
          if(a.id < b.id) { return -1; }
          if(a.id > b.id) { return 1; }
          return 0;
        })
        data.out.sort(function(a, b){
          if(a.id < b.id) { return -1; }
          if(a.id > b.id) { return 1; }
          return 0;
        })
        this.characteristics = this.characteristicsConverter.convert(data);
      }
    );
  }


}
